import { Notification } from "../../_app/types";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Log from "./BotLog";
import Text from "../Text";
import EmptyState from "../EmptyState/EmptyState";

interface Props {
  logs: Notification[];
}

const BotLogs = ({ logs }: Props) => {
  const theme = useTheme();

  if (!logs || !logs.length) {
    return (
      <Stack direction="row" justifyContent="center" alignItems="center" height="100%" mt="-45px">
        <EmptyState text="Logs not found" />
      </Stack>
    );
  }

  return (
    <Box height="100%">
      <Box
        sx={{
          borderBottom: `1px solid ${theme.myTheme.colors.foreground50}`,
          pb: "8px",
        }}
      >
        <Stack direction={"row"} gap="19px">
          <Text variant="regular">Date & Time</Text>
          <Text variant="regular">Event</Text>
        </Stack>
      </Box>
      <Stack direction={"column"} gap="8px">
        {logs.map((log, index) => (
          <Log key={index} log={log} />
        ))}
      </Stack>
    </Box>
  );
};

export default BotLogs;
